<template>
  <v-container>
    <btn-a class="ma-2" outlined rounded color="primary" @click="jobStageStatusDialogOpen">
      <v-icon>mdi-plus</v-icon>
    </btn-a>
    <v-list two-line subheader v-if="value.jobStageStatus">
      <div v-for="(item,i) in value.jobStageStatus" :key="i">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title v-text="item.status"></v-list-item-title>
            <v-list-item-subtitle v-text="item.description"></v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon @click="jobStageStatusDialogOpen(item)">
              <v-icon color="warning">mdi-pencil</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-action>
            <v-btn icon @click="jobStageStatusRemove(item)">
              <v-icon color="error">mdi-delete</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-divider v-if="value.jobStageStatus && value.jobStageStatus.length > 0"></v-divider>
      </div>
    </v-list>
    <dialog-d
      ref="jobStageStatusDialog"
      :title="$t('entities.environment.jobStageStatus.title')"
      @confirm="jobStageStatusConfirm"
      @cancel="jobStageStatusDialogCancel"
    >
      <jobStageStatusForm ref="form" v-model="jobStageStatusSelected" :status="jobStageStatusComp" />
    </dialog-d>
  </v-container>
</template>


<script>
import jobStageStatusForm from "../environments/jobStageStatusForm";
export default {
  components: { jobStageStatusForm },
  props: {
    value: {
      default: () => {
        return {
          description: "",
          jobStageStatus: [],
          jobStatus: [],
          calendarProds: [],
          calendarExcs: []
        };
      }
    }
  },
  data() {
    return {
      jobStageStatusSelected: {},
      jobStageStatusSelectedRef: null
    };
  },
  computed: {
    jobStageStatusComp() {
      let jobStageStatus = [];
      if (!this.value.jobStageStatus) return;
      this.value.jobStageStatus.forEach(js => {
        if (js.status != this.jobStageStatusSelected.status)
          jobStageStatus.push(js.status);
      });
      return jobStageStatus;
    }
  },
  methods: {
    jobStageStatusDialogCancel() {
      this.jobStageStatusSelectedRef = null;
    },
    jobStageStatusConfirm() {
      if(!this.$refs.form.isValid()) return;
      if (this.jobStageStatusSelectedRef != null) {
        Object.assign(
          this.jobStageStatusSelectedRef,
          this.jobStageStatusSelected
        );
      } else {
        this.value.jobStageStatus.push(this.jobStageStatusSelected);
      }
      this.$refs.jobStageStatusDialog.open();
      this.jobStageStatusSelectedRef = null;
    },
    jobStageStatusRemove(jobStageStatus) {
      let index = this.value.jobStageStatus.indexOf(jobStageStatus);
      if (index >= 0) this.value.jobStageStatus.splice(index, 1);
    },
    jobStageStatusDialogOpen(jobStageStatus) {
      if (jobStageStatus) {
        this.jobStageStatusSelectedRef = jobStageStatus;
        let obj = {};
        Object.assign(obj, jobStageStatus);
        this.jobStageStatusSelected = obj;
      } else {
        this.jobStageStatusSelected = {};
      }

      this.$refs.jobStageStatusDialog.open();
    }
  }
};
</script>